import { css } from '@microsoft/fast-element';
import { getToken } from '../design-tokens';

// TODO: Now that the natgen-heading component exists, phase out these styles.
export const typeRampStyles = css`
    h1, h2, h3, h4, h5, h6 {
        margin: 0;
        font-weight: 700;
    }

    h1 {
        font-size: ${getToken('typography-heading-large-font-size')};
        line-height: ${getToken('typography-heading-large-line-height')};
    }

    h2 {
        font-size: ${getToken('typography-heading-large-font-size')};
        line-height: ${getToken('typography-heading-large-line-height')};
    }

    h3 {
        font-size: ${getToken('typography-heading-font-size')};
        line-height: ${getToken('typography-heading-line-height')};
    }

    h4 {
        font-size: ${getToken('typography-heading-small-font-size')};
        line-height: ${getToken('typography-heading-small-line-height')};
    }

    h5 {
        font-size: ${getToken('typography-body-x-large-font-size')};
        line-height: ${getToken('typography-body-x-large-line-height')};
    }

    h6 {
        font-size: ${getToken('typography-body-large-font-size')};
        line-height: ${getToken('typography-body-large-line-height')};
    }
`;
